import { render } from "./AppRepairsBody.vue?vue&type=template&id=cad34e16"
import script from "./AppRepairsBody.vue?vue&type=script&lang=js"
export * from "./AppRepairsBody.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__